// eslint-disable-next-line import/prefer-default-export
export const DEFAULT_CONSTRAINTS = {
  width: {
    ideal: 1024
  },
  height: {
    ideal: 768
  },
  deviceId: 0,
  facingMode: 'environment'
};